const H_CAPTCHA_SITE_KEY = 'bccab396-8dcb-487c-b13a-b1698fb8c552';
const API_KEY = '0NwEHKjghwf90965Dd2pm2yYLE4+H5DxbA/vWdEHzIc=';
// const API_BASE_URL = 'http://localhost:8006';
const API_BASE_URL = 'https://api.motionenergy.com';

module.exports = {
    H_CAPTCHA_SITE_KEY,
    API_BASE_URL,
    API_KEY
};
